export default "__VITE_ASSET__18d4e469__"